module.exports = __webpack_public_path__ + "d3048dc5444029e571697505023341f9.glb";